import { FunctionComponent, memo, SVGProps } from 'react';
import { HeroIcon } from '../../types';
import classNames from 'classnames';

interface IconBoxProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  icon?:
    | HeroIcon
    | FunctionComponent<
        SVGProps<SVGSVGElement> & {
          title?: string;
        }
      >;
  text?: string;
  highlight?: boolean;
  grayedOut?: boolean;
  className?: string;
}
const IconBox_: React.FC2<IconBoxProps> = ({ icon: Icon, text, highlight, grayedOut, className, ...props }) => {
  return (
    <div
      className={classNames(
        'flex items-center justify-center cursor-pointer w-9 h-9',
        !highlight && 'bg-[rgb(230,230,230)] dark:bg-[rgb(33,33,33)] dark:text-white hover:bg-neon-green-300 dark:hover:text-neon-green-300 dark:hover:bg-[#868994]',
        highlight && 'bg-neon-green-500 text-black',
        grayedOut && 'text-[#6F7173] hover:text-black',
        className,
      )}
      {...props}
    >
      {Icon && <Icon className="w-4 h-4" />}
      {text && <div>{text}</div>}
    </div>
  );
};
export const IconBox = memo(IconBox_);
